export const HOME = {
  emergentLink: "emergent-link",

  // Header / Nav
  headerLogo: "header-logo",
  navProducts: "nav-products",
  navProcess: "nav-process",
  navWhy: "nav-why",
  navFaq: "nav-faq",
  agentLogin: "agent-login-link",
  merchantLogin: "merchant-login-link",
  heroApplyBtn: "hero-apply-btn",
  navApplyBtn: "nav-apply-btn",

  // Hero
  heroDirectLenderBadge: "hero-direct-lender-badge",
  heroHeadline: "hero-headline",
  heroTalkBtn: "hero-talk-btn",

  // Products
  productCardWorkingCapital: "product-working-capital",
  productCardEquipment: "product-equipment-financing",
  productCardSba: "product-sba",
  productCardHeloc: "product-heloc",
  productCardFactoring: "product-invoice-factoring",
  productCardLoc: "product-line-of-credit",

  // Apply form
  applyForm: "apply-form",
  applyBusinessName: "apply-business-name",
  applyContactName: "apply-contact-name",
  applyEmail: "apply-email",
  applyPhone: "apply-phone",
  applyAmount: "apply-amount",
  applyProduct: "apply-product",
  applyRevenue: "apply-revenue",
  applyTib: "apply-tib",
  applyNotes: "apply-notes",
  applyPassword: "apply-password",
  applySubmit: "apply-submit",
  applySuccess: "apply-success",
  applyError: "apply-error",
};
